import { getInputVariableValue } from './getInputVariableValue';

export const formatDataTypeName = (name: string) =>
  getInputVariableValue(name).toUpperCase();
